const modules = {

}

const state = {

}

const getters = {
	hasPoolsAtLevel: (state, getters, rootState) => (concernedLevel) => {
		var levels = rootState.Character.Levels
		for (const level in levels) {
			if(level <= concernedLevel && levels[level].Pools != undefined){
				return true
			}
		}
		return false
	},
	poolsAtLevel: (state, getters, rootState) => (concernedLevel) => {
		return rootState.Character.Levels[concernedLevel].Pools || null;
	},
	valueOrNull: (state, getters, rootState) => (key, level, id) => {
		if(rootState.Character.Levels[level].Pools[id] !== undefined){
			return rootState.Character.Levels[level].Pools[id][key]
		}else{
			return null;
		}
	},
	name: (state, getters) => (level, id) => {
		return getters.valueOrNull('Name', level, id)
	},
	currentPoints: (state, getters) => (level, id) => {
		return getters.valueOrNull('CurrentPoints', level, id)
	},
	maxPoints: (state, getters) => (level, id) => {
		return getters.valueOrNull('MaxPoints', level, id)
	},
}

const mutations = {
	
}

const actions = {

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
	modules,
}